import { render, staticRenderFns } from "./CopyToPlatformModal.vue?vue&type=template&id=e1bf4a9e&"
import script from "./CopyToPlatformModal.vue?vue&type=script&lang=ts&"
export * from "./CopyToPlatformModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports